import { render, staticRenderFns } from "./baobiaostu.vue?vue&type=template&id=e025c480&scoped=true"
import script from "./baobiaostu.vue?vue&type=script&lang=js"
export * from "./baobiaostu.vue?vue&type=script&lang=js"
import style0 from "./baobiaostu.vue?vue&type=style&index=0&id=e025c480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e025c480",
  null
  
)

export default component.exports